import { Component } from "react"

class SelfIntroduction extends Component{
    constructor(props){
        super(props)
        this.name = "自己紹介"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 2000){
                callbackDialog("エラー",this.name + "は2000文字以内にしてください。")
                return false
            }
        }
        return true
    }
}

export default SelfIntroduction;